import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66d4fff8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto max-w-xl p-8 py-3 md:px-18" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-2xl font-semibold" }
const _hoisted_4 = { class: "relative mt-7" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 2,
  class: "tooltip tooltip-bottom absolute -right-4 top-3 flex items-center pr-6 text-green-500",
  "data-tip": "Copied"
}
const _hoisted_8 = ["href"]

import {
  PhCheck,
  PhCopy,
} from '@phosphor-icons/vue';
import {
  computed,
  ref,
} from 'vue';
import {
  copyToClipboard,
  supportMenuList,
} from '@/helpers';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CallOrMessageSupport',
  setup(__props) {

const authStore = useStore.auth;
const utilStore = useStore.util;

const id = computed(() => utilStore.supportId);
const companyEmail = computed(() => authStore.company?.contactSettings?.email);
const companyPhoneNo = computed(() => authStore.company?.contactSettings?.phoneNo);
const isTextCopied = ref(false);

const title = computed(() => {
  const support = supportMenuList.find((item) => item.id === id.value);
  return support ? support.text : '';
});

let copyButtonClickTimeout: ReturnType<typeof setTimeout> | undefined;

async function handleCopyText(): Promise<void> {
  const text = id.value === 1 ? companyPhoneNo.value : companyEmail.value;
  await copyToClipboard(text as string);

  if (copyButtonClickTimeout) {
    clearTimeout(copyButtonClickTimeout);
    copyButtonClickTimeout = undefined;
  }

  isTextCopied.value = true;

  copyButtonClickTimeout = setTimeout(() => {
    isTextCopied.value = false;
  }, 1000 * 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("p", null, " Feel free to contact us at the " + _toDisplayString(id.value === 2 ? 'email' : 'mobile number') + " provided. ", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (id.value === 2)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "text",
            readonly: "",
            value: companyEmail.value,
            class: "mb-3 w-full rounded-md border py-3 pl-4 pr-8 text-gray-700 shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
          }, null, 8, _hoisted_5))
        : (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            readonly: "",
            value: companyPhoneNo.value,
            class: "mb-3 w-full rounded-md border py-3 pl-4 pr-8 text-gray-700 shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
          }, null, 8, _hoisted_6)),
      (isTextCopied.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(PhCheck), { class: "size-5" })
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "absolute -right-4 top-4 flex items-center pr-6 hover:text-red-500",
            onClick: handleCopyText
          }, [
            _createVNode(_unref(PhCopy), { class: "size-5" })
          ]))
    ]),
    _createElementVNode("a", {
      href: id.value === 1 ? `tel:${companyPhoneNo.value}` : `mailto:${companyEmail.value}`,
      class: "btn flex items-center justify-center"
    }, _toDisplayString(id.value === 1 ? 'Call Now' : 'Send Mail'), 9, _hoisted_8)
  ]))
}
}

})